import React from 'react';

// Custom SVG Icons for Learning Pillars
export const StockMarketIcon = ({ size = 60, color = "#3498db" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="10" width="80" height="80" rx="8" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M20 70L35 55L50 65L65 45L80 35" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="20" cy="70" r="3" fill={color}/>
    <circle cx="35" cy="55" r="3" fill={color}/>
    <circle cx="50" cy="65" r="3" fill={color}/>
    <circle cx="65" cy="45" r="3" fill={color}/>
    <circle cx="80" cy="35" r="3" fill={color}/>
    <rect x="15" y="25" width="4" height="8" fill={color} fillOpacity="0.6"/>
    <rect x="25" y="20" width="4" height="13" fill={color} fillOpacity="0.6"/>
    <rect x="35" y="15" width="4" height="18" fill={color} fillOpacity="0.6"/>
  </svg>
);

export const InvestmentIcon = ({ size = 60, color = "#27ae60" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="40" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M30 50h40M50 30v40" stroke={color} strokeWidth="3" strokeLinecap="round"/>
    <circle cx="50" cy="50" r="8" fill={color}/>
    <path d="M35 35L50 20L65 35" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M35 65L50 80L65 65" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="20" y="45" width="10" height="10" rx="2" fill={color} fillOpacity="0.6"/>
    <rect x="70" y="45" width="10" height="10" rx="2" fill={color} fillOpacity="0.6"/>
  </svg>
);

export const TradingIcon = ({ size = 60, color = "#e74c3c" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="20" width="80" height="60" rx="6" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M20 60L30 45L40 55L50 35L60 50L70 30L80 40" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="25" y="65" width="6" height="10" fill="#27ae60"/>
    <rect x="35" y="62" width="6" height="13" fill="#27ae60"/>
    <rect x="45" y="68" width="6" height="7" fill="#e74c3c"/>
    <rect x="55" y="64" width="6" height="11" fill="#27ae60"/>
    <rect x="65" y="66" width="6" height="9" fill="#e74c3c"/>
    <circle cx="50" cy="35" r="2" fill={color}/>
    <path d="M45 30L50 25L55 30" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const RiskManagementIcon = ({ size = 60, color = "#f39c12" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M50 15L65 35H35L50 15Z" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <circle cx="50" cy="60" r="25" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <path d="M40 60L47 67L60 54" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="47" y="20" width="6" height="8" fill={color}/>
    <circle cx="50" cy="32" r="2" fill={color}/>
    <path d="M30 45L35 40L40 45" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M70 45L65 40L60 45" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const MarketAnalysisIcon = ({ size = 60, color = "#9b59b6" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="35" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <circle cx="50" cy="50" r="20" fill="none" stroke={color} strokeWidth="2"/>
    <circle cx="50" cy="50" r="8" fill={color}/>
    <path d="M50 15V25M85 50H75M50 85V75M15 50H25" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M71 29L65 35M71 71L65 65M29 71L35 65M29 29L35 35" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <rect x="45" y="30" width="10" height="4" rx="2" fill={color} fillOpacity="0.6"/>
    <rect x="60" y="45" width="4" height="10" rx="2" fill={color} fillOpacity="0.6"/>
  </svg>
);

export const TradingPlatformsIcon = ({ size = 60, color = "#34495e" }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="15" y="25" width="70" height="45" rx="4" fill={color} fillOpacity="0.1" stroke={color} strokeWidth="2"/>
    <rect x="20" y="30" width="60" height="25" rx="2" fill={color} fillOpacity="0.2"/>
    <circle cx="25" cy="35" r="2" fill="#e74c3c"/>
    <circle cx="32" cy="35" r="2" fill="#f39c12"/>
    <circle cx="39" cy="35" r="2" fill="#27ae60"/>
    <rect x="25" y="42" width="15" height="2" rx="1" fill={color} fillOpacity="0.6"/>
    <rect x="25" y="46" width="25" height="2" rx="1" fill={color} fillOpacity="0.6"/>
    <rect x="25" y="50" width="20" height="2" rx="1" fill={color} fillOpacity="0.6"/>
    <rect x="55" y="42" width="20" height="12" rx="2" fill={color} fillOpacity="0.3"/>
    <path d="M60 47L65 52L70 47" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="35" y="75" width="30" height="4" rx="2" fill={color} fillOpacity="0.4"/>
  </svg>
);

// Decorative Elements
export const BackgroundPattern = () => (
  <svg className="position-absolute" style={{top: 0, left: 0, width: '100%', height: '100%', zIndex: -1}} viewBox="0 0 1000 600" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="grid" width="50" height="50" patternUnits="userSpaceOnUse">
        <path d="M 50 0 L 0 0 0 50" fill="none" stroke="rgba(52, 152, 219, 0.1)" strokeWidth="1"/>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#grid)" />
    <circle cx="100" cy="100" r="2" fill="rgba(52, 152, 219, 0.2)"/>
    <circle cx="300" cy="150" r="1.5" fill="rgba(52, 152, 219, 0.2)"/>
    <circle cx="500" cy="80" r="2.5" fill="rgba(52, 152, 219, 0.2)"/>
    <circle cx="700" cy="200" r="1" fill="rgba(52, 152, 219, 0.2)"/>
    <circle cx="900" cy="120" r="2" fill="rgba(52, 152, 219, 0.2)"/>
  </svg>
);

export const StockChartGraphic = ({ width = 300, height = 200 }) => (
  <svg width={width} height={height} viewBox="0 0 300 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="chartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#3498db" stopOpacity="0.3"/>
        <stop offset="100%" stopColor="#3498db" stopOpacity="0.05"/>
      </linearGradient>
    </defs>
    <path d="M20 180L50 160L80 140L110 120L140 100L170 80L200 60L230 40L260 20L280 30" 
          stroke="#3498db" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 180L50 160L80 140L110 120L140 100L170 80L200 60L230 40L260 20L280 30L280 180L20 180Z" 
          fill="url(#chartGradient)"/>
    <circle cx="50" cy="160" r="3" fill="#3498db"/>
    <circle cx="110" cy="120" r="3" fill="#3498db"/>
    <circle cx="170" cy="80" r="3" fill="#3498db"/>
    <circle cx="230" cy="40" r="3" fill="#3498db"/>
    <text x="20" y="195" fontSize="12" fill="#7f8c8d">2020</text>
    <text x="120" y="195" fontSize="12" fill="#7f8c8d">2022</text>
    <text x="220" y="195" fontSize="12" fill="#7f8c8d">2024</text>
  </svg>
);

export const PortfolioWheel = ({ size = 200 }) => (
  <svg width={size} height={size} viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="100" r="80" fill="#3498db" fillOpacity="0.8"/>
    <path d="M100 20A80 80 0 0 1 156.57 43.43L100 100Z" fill="#27ae60" fillOpacity="0.8"/>
    <path d="M156.57 43.43A80 80 0 0 1 180 100L100 100Z" fill="#e74c3c" fillOpacity="0.8"/>
    <path d="M180 100A80 80 0 0 1 156.57 156.57L100 100Z" fill="#f39c12" fillOpacity="0.8"/>
    <path d="M156.57 156.57A80 80 0 0 1 100 180L100 100Z" fill="#9b59b6" fillOpacity="0.8"/>
    <circle cx="100" cy="100" r="25" fill="white"/>
    <text x="100" y="105" textAnchor="middle" fontSize="12" fill="#2c3e50" fontWeight="bold">Portfolio</text>
    <text x="130" y="60" fontSize="10" fill="white" fontWeight="bold">Stocks</text>
    <text x="165" y="105" fontSize="10" fill="white" fontWeight="bold">Bonds</text>
    <text x="130" y="150" fontSize="10" fill="white" fontWeight="bold">REITs</text>
    <text x="70" y="150" fontSize="10" fill="white" fontWeight="bold">Commodities</text>
    <text x="70" y="60" fontSize="10" fill="white" fontWeight="bold">Cash</text>
  </svg>
);
